"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SESSION_EMPTY_RESPONSE = exports.SESSION_EMPTY_METADATA = exports.SESSION_EMPTY_STATE = exports.SESSION_EMPTY_PERMISSIONS = exports.SESSION_EVENTS = exports.SESSION_STATUS = exports.SESSION_SIGNAL_METHOD_PAIRING = exports.SESSION_DEFAULT_TTL = exports.SESSION_CONTEXT = exports.SESSION_JSONRPC = void 0;
const time_1 = require("./time");
exports.SESSION_JSONRPC = {
    propose: "wc_sessionPropose",
    approve: "wc_sessionApprove",
    reject: "wc_sessionReject",
    update: "wc_sessionUpdate",
    upgrade: "wc_sessionUpgrade",
    delete: "wc_sessionDelete",
    payload: "wc_sessionPayload",
    ping: "wc_sessionPing",
    notification: "wc_sessionNotification",
};
exports.SESSION_CONTEXT = "session";
exports.SESSION_DEFAULT_TTL = time_1.SEVEN_DAYS;
exports.SESSION_SIGNAL_METHOD_PAIRING = "pairing";
exports.SESSION_STATUS = {
    proposed: "proposed",
    responded: "responded",
    pending: "pending",
    settled: "settled",
};
exports.SESSION_EVENTS = {
    proposed: "session_proposed",
    responded: "session_responded",
    settled: "session_settled",
    updated: "session_updated",
    deleted: "session_deleted",
    notification: "session_notification",
    request: "session_request",
    response: "session_response",
};
exports.SESSION_EMPTY_PERMISSIONS = {
    jsonrpc: {
        methods: [],
    },
    blockchain: {
        chains: [],
    },
    notifications: {
        types: [],
    },
};
exports.SESSION_EMPTY_STATE = {
    accounts: [],
};
exports.SESSION_EMPTY_METADATA = {
    name: "",
    description: "",
    url: "",
    icons: [],
};
exports.SESSION_EMPTY_RESPONSE = {
    metadata: exports.SESSION_EMPTY_METADATA,
    state: exports.SESSION_EMPTY_STATE,
};
//# sourceMappingURL=session.js.map